<template>
<div>
   <div class="title">
    <span class="link">应用管理 ></span> <span class="curLink">申请记录</span>   
   </div>
   <div class="content">
     <div class="pageList">
         <div class="list">
        <template v-if="list.length">
           <div class="listItem" v-for="item in list" :key="item.id">
              <div class="pageTitle">
                <span class="name">{{item.applicationName}}</span>
                <template v-if="item.status === 0">
                  <span class="status status0">审核中</span>
                </template>
                <template v-if="item.status === 1">
                  <span class="status status1">通过</span>
                </template>
                <template v-if="item.status === 2">
                  <span class="status status2">不通过</span>
                </template>
                <!-- <div class="btn" v-if="item.status == 1">
                  <a :href="item.linkUrl ? item.linkUrl : ''" target="_blank">
                  <div>跳转后台</div>
                  <img src="../../assets/images/rightArrow.png" alt="">
                  </a>
                </div> -->
              </div>
              <!-- <div class="pageContent">
                <div>
                  <span class="label">申请企业</span>
                  <span>{{item.companyName}}</span>
                </div>
                <div>
                  <span class="label">联系电话</span>
                  <span>{{item.phone}}</span>
                </div>
                <div>
                  <span class="label">申请用途</span>
                  <span>{{item.purpose}}</span>
                </div>
              </div> -->
              <div class="pageContent">
                <div>
                  <span class="label">申请时间</span>
                  <span>{{item.createTime}}</span>
                </div>
                <template v-if="item.status!== 0">
                  <div>
                    <span class="label">审核时间</span>
                    <span>{{item.approveTime}}</span>
                  </div>
                  <div v-if="item.reason">
                    <span class="label">审核备注</span>
                    <span>{{item.reason}}</span>
                  </div>
                </template>
              </div>
              <div class="pageContent">
                <div class="ts">
                  <span class="label">应用描述</span>
                  <span>{{item.describe}}</span>
                </div>
              </div>

            </div>
            <!--一条数据结束-->
        </template>
        <template v-else>
          <Nodata />
        </template>

            
          </div>
          <div class="pageBox">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNum"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next"
              :total="total">
            </el-pagination>
          </div>
     </div>
   </div>
</div>    
</template>
<script>
import { fetchUserAppList } from '@/api/api'
import Nodata from '@/components/noData.vue'
export default {
    data() {
      return {
        total: 0,
        pageNum: 1,
        pageSize: 10,
        list: [],
        loading: false,
      }
    },
    created() {
      this.getList()
    },
    components:{
      Nodata
    },
    methods: {
      handleSizeChange(val) {
        this.pageSize = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.pageNum = val
        this.getList()
      },
      getList() {
        let params = {
          page: this.pageNum - 1,
          size: this.pageSize
        }
        fetchUserAppList(params).then(res => {
          this.list = res.data.content
          this.total = Number(res.data.totalElements)
        })
      }
    },
}
</script>

<style scoped>
.title {
    height: 66px;
    line-height: 66px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #282F3D;
    padding-left: 30px;
    background: #fff;
  }
  .curLink{
    cursor: pointer;
  }
  .link{
    color: rgba(144, 157, 177, 1);
  }
  .content {
    box-sizing: border-box;
    padding: 10px 20px;
  }

  .pageList {
    width: 100%;
    height: calc(100vh - 180px);
    background: #FFFFFF;
    box-shadow: 1px 3px 16px 0px rgba(204, 211, 228, 0.51);
    border-radius: 8px;
    box-sizing: border-box;
    padding: 20px 40px;
  }

  .listItem {
    padding: 10px 0;
    border-bottom: 1px solid #E8EBF4;
    position: relative;
  }

  .status {
    background: rgba(34,94,253,0.1);
    border: 1px solid #225EFD;
    border-radius: 22px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #225EFD;
    text-align: center;
    padding: 3px 15px;
    margin-left: 10px;
  }
  .status0{

  }
  .status1{
    background: rgba(13,193,110,0.1);
    color: #29C87E;
    border: 1px solid #0DC16E;
  }
  .status2{
    background: rgba(255,111,5,0.1);
    color: #FF8D3A;
    border: 1px solid #FF8D3A;
  }

  .pageTitle {
    padding: 15px 0;
  }

  .pageContent {
    padding: 15px 0 0;
    display: flex;
    justify-content: flex-start;
  }

  .pageContent > div {
    width: 30%;
  }
  
  .pageContent > div.ts {
    width: 90%;
  }

  .pageBox{
    display: flex;
    justify-content: flex-end;
  }
  .list{
    height: calc(100vh - 280px);
    overflow-y: scroll;
  }
  .list::-webkit-scrollbar { width: 0 !important }
  .label{
    color: #909DB1;
    padding-right: 20px;
    min-width: 80px;
  }

    .btn {
    width: 135px;
    height: 43px;
    border: 1px solid #0F5EFF;
    border-radius: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0px;
    bottom: 20px;
    cursor: pointer;

  }
  .btn a {
    display: block;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .btn img {
    margin-top: 3px;
    margin-left: 5px;
    /* width: 18px;
    height: 9px; */
  }

  .btn  div {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #0F5EFF;
    text-align: center;
    /* line-height: 43px; */
  }

  .tabList {
    height: 40px;
    display: flex;
    justify-content: flex-start;
    margin-top: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/views/console/MyApply.vue